import { blogPostRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const blogPostRouteMetadata: IRouteMetadataObj<typeof blogPostRoutesObj> = {
  list: {
    title: "blogPost.index.title",
    description: "blogPost.index.description",
    lazy: () => import("@/pages/blogPost/table/page"),
    mode: "index",
    type: "main",
    icon: "BookLine",
    breadcrumbs: [],
    permission,
  },
  create: {
    title: "blogPost.create.title",
    description: "blogPost.create.description",
    lazy: () => import("@/pages/blogPost/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "blogPost.edit.title",
    description: "blogPost.edit.description",
    lazy: () => import("@/pages/blogPost/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "blogPost.edit.title",
    description: "blogPost.edit.description",
    lazy: () => import("@/pages/blogPost/form/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
};

export const blogPostRoutes = createRoute<typeof blogPostRoutesObj>(
  blogPostRoutesObj,
  blogPostRouteMetadata,
);
